<template lang="pug">
  .room.circulating-fan(v-loading="loadingData")
    .divice-block-multi
      single-histogram.divice-block-multi-item(:opts="singleHisOpts1" :series="cycleTemp1" :class="warningFlag1")
      single-histogram.divice-block-multi-item(:opts="singleHisOpts2" :series="cycleTemp2" :class="warningFlag2")
      single-histogram.divice-block-multi-item(:opts="singleHisOpts3" :series="cycleTemp3" :class="warningFlag3")
      single-histogram.divice-block-multi-item(:opts="singleHisOpts4" :series="cycleTemp4" :class="warningFlag4")
    .divice-block-line
      .divice-block-line-item
        .divice-block-line-item-two
          SwitchStatus.divice-block-thin(title="风机1运行" :series="SwitchStatusData1")
          SwitchStatus.divice-block-thin(title="风机1故障" :series="SwitchStatusData2")
        .divice-block-line-item-two
          SwitchStatus.divice-block-thin(title="风机2运行" :series="SwitchStatusData3")
          SwitchStatus.divice-block-thin(title="风机2故障" :series="SwitchStatusData4")
        .divice-block-line-item-two
          SwitchStatus.divice-block-thin(title="风机3运行" :series="SwitchStatusData5")
          SwitchStatus.divice-block-thin(title="风机3故障" :series="SwitchStatusData6")
        .divice-block-line-item-two
          SwitchStatus.divice-block-thin(title="风机4运行" :series="SwitchStatusData7")
          SwitchStatus.divice-block-thin(title="风机4故障" :series="SwitchStatusData8")
        .divice-block-line-item-two
          SwitchStatus.divice-block-thin(title="风机5运行" :series="SwitchStatusData9")
          SwitchStatus.divice-block-thin(title="风机5故障" :series="SwitchStatusData10")
        RunningTimeBig.divice-block-time(title="风机1运行时间" :series="RunningTimeData1")
      .divice-block-line-item-gra
        .divice-block-line-item-gra-two
          RunningTimeBig.divice-block-time(title="风机2运行时间" :series="RunningTimeData2")
          RunningTimeBig.divice-block-time(title="风机3运行时间" :series="RunningTimeData3")
        .divice-block-line-item-gra-two
          RunningTimeBig.divice-block-time(title="风机4运行时间" :series="RunningTimeData4")
          RunningTimeBig.divice-block-time(title="风机5运行时间" :series="RunningTimeData5")
    RefreshBlock(@refreshData="refreshData")
</template>
<script>
import nizhouConfigJSON from './config/circulatingFan_data.json'

export default {
  name: 'circulatingFan',
  data() {
    return {
      timer: null,
      loadingData: false,
      warningFlag1: '',
      warningFlag2: '',
      warningFlag3: '',
      warningFlag4: '',
      cycleTemp1: {},
      cycleTemp2: {},
      cycleTemp3: {},
      cycleTemp4: {},
      deviceList: [],
      singleHisOpts1: {
        title: '外循环进口温度',
        histogramName1: '',
        sign: '°C',
        max: 100
      },
      singleHisOpts2: {
        title: '外循环出口温度',
        histogramName1: '',
        sign: '°C',
        max: 100
      },
      singleHisOpts3: {
        title: '内循环进口温度',
        histogramName1: '',
        sign: '°C',
        max: 100
      },
      singleHisOpts4: {
        title: '内循环出口温度',
        histogramName1: '',
        sign: '°C',
        max: 100
      },
      RunningTimeData1: null,
      RunningTimeData2: null,
      RunningTimeData3: null,
      RunningTimeData4: null,
      RunningTimeData5: null,
      SwitchStatusData1: null,
      SwitchStatusData2: null,
      SwitchStatusData3: null,
      SwitchStatusData4: null,
      SwitchStatusData5: null,
      SwitchStatusData6: null,
      SwitchStatusData7: null,
      SwitchStatusData8: null,
      SwitchStatusData9: null,
      SwitchStatusData10: null
    }
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
    this.resetData()
      this.loadingData = true
      this.getDatas()
    }
  },
  mounted() {
    this.getDatas()
    this.timer = setInterval(() => {
      this.getDatas()
    }, this.REFRESH_SECOND)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    resetData() {
      this.warningFlag1 = ''
      this.warningFlag2 = ''
      this.warningFlag3 = ''
      this.warningFlag4 = ''
    },
    getInfo() {
      const routerPath = this.$route.name.split('_')
      this.deviceList = nizhouConfigJSON[routerPath[1]].deviceList
      const stationId = nizhouConfigJSON[routerPath[1]].stationId
      this.$http.get(`/bridge/StationInfo?stationId=${stationId}`).then(res => {
        const __data = res.data.deviceList
        const list = __data.map(el => {
          return {
            deviceId: el.deviceId,
            deviceName: el.deviceName
          }
        })
        console.log('list', JSON.stringify(list))
      })
    },
    refreshData() {
      this.getDatas()
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.getDatas()
      }, this.REFRESH_SECOND)
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find(el => {
        return el.deviceName === deviceName
      })
      if (!device) {
        console.log(`deviceName${deviceName}###`)
      }
      return device.deviceId || ''
    },
    findDeviceData(dataList, deviceName) {
      const deviceId = this.findDeviceId(deviceName)
      const device = dataList[deviceId]
      return {
        value: device.value,
        errorLevel: device.errorLevel
      }
    },
    getDatas() {
      const routerPath = this.$route.name.split('_')
      this.deviceList = nizhouConfigJSON[routerPath[1]].deviceList
      const deviceDataName =
        nizhouConfigJSON[routerPath[1]][routerPath[2]].deviceDataName
      const stationId = nizhouConfigJSON[routerPath[1]].stationId
      this.$http.get(`/deviceData/Station?stationId=${stationId}`).then(res => {
        this.loadingData = false
        this.$store.commit('setLastRefreshTime')
        const __data = res.data
        const findDeviceData1 = this.findDeviceData(__data, deviceDataName[0])
        const findDeviceData2 = this.findDeviceData(__data, deviceDataName[1])
        const findDeviceData3 = this.findDeviceData(__data, deviceDataName[2])
        const findDeviceData4 = this.findDeviceData(__data, deviceDataName[3])
        this.cycleTemp1 = {
          data: findDeviceData1.value
        }
        this.warningFlag1 = findDeviceData1.errorLevel
        this.cycleTemp2 = {
          data: findDeviceData2.value
        }
        this.warningFlag2 = findDeviceData2.errorLevel
        this.cycleTemp3 = {
          data: findDeviceData3.value
        }
        this.warningFlag3 = findDeviceData3.errorLevel
        this.cycleTemp4 = {
          data: findDeviceData4.value
        }
        this.warningFlag4 = findDeviceData4.errorLevel
        this.SwitchStatusData1 = {
          data: __data[this.findDeviceId(deviceDataName[4])].value,
          isError: __data[this.findDeviceId(deviceDataName[4])].errorLevel
        }
        this.SwitchStatusData2 = {
          data: __data[this.findDeviceId(deviceDataName[5])].value,
          isZh: true,
          isError: __data[this.findDeviceId(deviceDataName[5])].errorLevel
        }
        this.SwitchStatusData3 = {
          data: __data[this.findDeviceId(deviceDataName[6])].value,
          isError: __data[this.findDeviceId(deviceDataName[6])].errorLevel
        }
        this.SwitchStatusData4 = {
          data: __data[this.findDeviceId(deviceDataName[7])].value,
          isZh: true,
          isError: __data[this.findDeviceId(deviceDataName[7])].errorLevel
        }
        this.SwitchStatusData5 = {
          data: __data[this.findDeviceId(deviceDataName[8])].value,
          isError: __data[this.findDeviceId(deviceDataName[8])].errorLevel
        }
        this.SwitchStatusData6 = {
          data: __data[this.findDeviceId(deviceDataName[9])].value,
          isZh: true,
          isError: __data[this.findDeviceId(deviceDataName[9])].errorLevel
        }
        this.SwitchStatusData7 = {
          data: __data[this.findDeviceId(deviceDataName[10])].value,
          isError: __data[this.findDeviceId(deviceDataName[10])].errorLevel
        }
        this.SwitchStatusData8 = {
          data: __data[this.findDeviceId(deviceDataName[11])].value,
          isZh: true,
          isError: __data[this.findDeviceId(deviceDataName[11])].errorLevel
        }
        this.SwitchStatusData9 = {
          data: __data[this.findDeviceId(deviceDataName[12])].value,
          isError: __data[this.findDeviceId(deviceDataName[12])].errorLevel
        }
        this.SwitchStatusData10 = {
          data: __data[this.findDeviceId(deviceDataName[13])].value,
          isZh: true,
          isError: __data[this.findDeviceId(deviceDataName[13])].errorLevel
        }
        this.RunningTimeData1 =
          __data[this.findDeviceId(deviceDataName[14])].value
        this.RunningTimeData2 =
          __data[this.findDeviceId(deviceDataName[15])].value
        this.RunningTimeData3 =
          __data[this.findDeviceId(deviceDataName[16])].value
        this.RunningTimeData4 =
          __data[this.findDeviceId(deviceDataName[17])].value
        this.RunningTimeData5 =
          __data[this.findDeviceId(deviceDataName[18])].value
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.circulating-fan {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  .divice-block-multi {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    &-item {
      width: calc((100% / 4) - 10px);
      background-color: rgba(255, 255, 255, 0.6);
    }
  }
  .divice-block-line {
    width: 100%;
    height: calc(50% - 10px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    &-item {
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      align-items: stretch;
      flex-direction: column;
      width: calc(100% / 5 * 2 - 6px);
      &-two {
        display: flex;
        box-sizing: border-box;
        justify-content: space-between;
        .divice-block-thin {
          height: 42px;
          width: calc(50% - 6px);
          box-sizing: border-box;
        }
      }
      .divice-block-time {
        height: calc(100% - 270px);
        width: 100%;
        box-sizing: border-box;
      }
    }
    &-item-gra {
      width: calc(100% / 5 * 3 - 6px);
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      align-items: stretch;
      flex-direction: column;
      &-two {
        height: calc(50% - 6px);
        width: 100%;
        display: flex;
        box-sizing: border-box;
        justify-content: space-between;
        .divice-block-time {
          height: 100%;
          width: calc(50% - 6px);
          box-sizing: border-box;
        }
      }
    }
  }
}
</style>
